import { unprefix } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { quote } from '../../partials/quote';

export const quoteSlice = ({ primary }) => {
  const normalized = quote(unprefix('slice', primary));
  if (normalized) {
    return {
      type: CommonSliceType.QUOTE,
      ...normalized,
    };
  }
};
